<div class="textfield">
  <label [for]="id">{{ label | i18next }}</label>
  <div class="input">
    <input
      type="text"
      [id]="id"
      placeholder="{{ placeholder ? (placeholder | i18next) : '' }}"
      [ngClass]="{ error: hasError }"
      [attr.aria-required]="isRequired"
      [attr.aria-invalid]="hasError"
      [attr.aria-describedby]="errorId"
      [(ngModel)]="value"
      (blur)="markAsTouched()"
      (keydown)="handleKeydown($event)"
    />
    <i class="fa fa-exclamation-triangle" aria-hidden="true" *ngIf="hasError">
    </i>
  </div>
  <span class="app-error-text" [id]="errorId">
    {{ hasError ? (errorText | i18next) : '' }}
  </span>
</div>
